import Button from 'baby-design/components/Button/Button'
import LinkOut from 'baby-design/icons/LinkOut.svg'
import { healthPath } from 'lib/urls'
import css from './BabylistHealthCTA.styles.scss'

export const BabylistHealthCTA = () => (
  <div className={css.BabylistHealthCTA}>
    <div className={css.BabylistHealthCTA__heading}>
      Let insurance pay for your pump!
    </div>
    <div className={css.BabylistHealthCTA__body}>
      Select an eligible breast pump from Babylist Health and insurance will
      cover up to 100% of the cost.
    </div>
    <Button
      className={css.BabylistHealthCTA__button}
      href={healthPath}
      target="_blank"
      icon={{ icon: <LinkOut />, side: 'right' }}
      size="sm"
      variant="inverted"
    >
      Check your eligibility
    </Button>
  </div>
)
